import { Inject, Injectable } from "@angular/core";
import { ENVIRONMENT } from "../modules/keycloak.module";
import type { IEnvironment } from "../models/interfaces/environment.interface";
import { UserSecurityModel } from "../models/user/user-security.model";
import { HttpParamsUtil } from "../utils/http-params.util";
import { Observable } from "rxjs";
import { RetryHttpClient } from "./base/retryable-http.client";

@Injectable({ providedIn: "root" })
export class UserService extends HttpParamsUtil {
  constructor(
    private readonly httpClient: RetryHttpClient,
    @Inject(ENVIRONMENT) private readonly environment: IEnvironment
  ) {
    super();
  }

  authenticate(token: string): Observable<UserSecurityModel> {
    return this.httpClient.post<{ token: string }, UserSecurityModel>(
      `${this.environment.BASE_URL}${this.environment.SECURITY["BASE"]}${this.environment.SECURITY["AUTHENTICATE"]}`,
      {
        token,
      }
    );
  }
}
